import type { ComponentProps } from "react"

export default function BYA(props: ComponentProps<"svg"> & { fill?: string }) {
  const { fill = "hsl(var(--foreground))", ...svgProps } = props

  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M0.626953 6.62646H6.62695M6.62695 0.626465V9.62646M1.62695 0.626465H8.62695C9.17924 0.626465 9.62695 1.07418 9.62695 1.62646V8.62647C9.62695 9.17875 9.17924 9.62646 8.62695 9.62646H1.62695C1.07467 9.62646 0.626953 9.17875 0.626953 8.62647V1.62646C0.626953 1.07418 1.07467 0.626465 1.62695 0.626465Z"
        stroke={fill}
        strokeWidth="1.2525"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
